import App from './App.vue';
import { createApp } from 'vue';

import { createI18n } from 'vue-i18n';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import nl from './locales/nl.json';
import it from './locales/it.json';
import se from './locales/se.json';

import router from './router/index';
import { isUsbTransferError } from './utility/usb';

const lg = localStorage.getItem('APP_LANGUAGE') ?? window.navigator.language;

const i18n = createI18n({
    legacy: false,
    locale: lg,
    fallbackLocale: 'en',
    messages: {
        fr: fr,
        gb: en,
        de: de,
        nl: nl,
        it: it,
        se: se
    }
});

// Gestionnaire global pour les erreurs de promesses non gérées
// Ignore les erreurs USB normales lors du reboot/déconnexion du device
window.addEventListener('unhandledrejection', (event) => {
    if (isUsbTransferError(event.reason)) {
        event.preventDefault();
        console.debug('USB transfer error ignored (device disconnected):', event.reason);
        return;
    }
});

function createVue(): void {
    const app = createApp(App).use(i18n).use(router);
    app.config.errorHandler = (err) => {
        // Ignorer les erreurs USB lors du reboot/déconnexion
        if (isUsbTransferError(err)) {
            console.debug('USB transfer error ignored (device disconnected):', err);
            return;
        }
        console.error('error', err);
    };
    app.mount('#app');
}

createVue();
